import { Check, Minus } from "lucide-react";
import { COLUMNS, ROWS } from "../../data/compareData";

const Cell = ({ value, highlight }) => {
  if (value === true) return <Check className={`w-5 h-5 mx-auto ${highlight ? "text-[#1A362D]" : "text-[#8B9D83]"}`} aria-label="Yes" />;
  if (value === false) return <Minus className="w-5 h-5 mx-auto text-[#C9C2B8]" aria-label="No" />;
  return <span className={`text-sm ${highlight ? "font-semibold" : "text-[#5C6B64]"}`}>{value}</span>;
};

export const CompareTable = ({ only }) => {
  const cols = only ? COLUMNS.filter((c) => only.includes(c.key)) : COLUMNS;
  return (
    <div className="overflow-x-auto rounded-xl border border-[#E5E1DB] bg-white" data-testid="compare-table">
      <table className="w-full min-w-[640px] text-left">
        <thead>
          <tr className="border-b border-[#E5E1DB]">
            <th className="p-4 text-xs tracking-[0.2em] uppercase font-semibold text-[#5C6B64] w-[34%]">Feature</th>
            {cols.map((c) => (
              <th key={c.key} className={`p-4 text-center font-display text-base ${c.key === "trackr" ? "bg-[#1A362D] text-[#F4F1EE]" : ""}`}>{c.name}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {ROWS.map((r) => (
            <tr key={r.label} className="border-b border-[#E5E1DB] last:border-0">
              <td className="p-4 text-sm">{r.label}</td>
              {cols.map((c) => (
                <td key={c.key} className={`p-4 text-center ${c.key === "trackr" ? "bg-[#E2F0E7]/60" : ""}`}>
                  <Cell value={r[c.key]} highlight={c.key === "trackr"} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
